import { apiPost } from '@/lib/api';

export async function updateOrganizationName(orgId: string, name: string): Promise<void> {
  await apiPost('/v1/organizations/rename', { orgId, name: name.trim() });
}
